import { type IMediator } from '#/core/mediator';

import { SERVICES_TYPES } from '#/services-types';

import { type IUrlParamsService, UrlParamsName } from '../url-params';

import { type IVirtualConsoleService } from './virtual-console.types';

export class VirtualConsoleService implements IVirtualConsoleService {
  get #urlParamsService() {
    return this._mediator.get<IUrlParamsService>(SERVICES_TYPES.UrlParamsService);
  }

  constructor(private readonly _mediator: IMediator) {}

  async start() {
    if (this.#urlParamsService.hasParamByName(UrlParamsName.Debug)) {
      const VConsole = (await import('vconsole')).default;

      const vConsole = new VConsole({ theme: 'dark' });

      vConsole.setSwitchPosition(0, 70);
    }
  }
}
